module.exports = __webpack_public_path__ + "static/media/airport.5862c7f7.jpg";